import { render, staticRenderFns } from "./DiscountTabs.vue?vue&type=template&id=88c7e518&"
import script from "./DiscountTabs.vue?vue&type=script&lang=js&"
export * from "./DiscountTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports